import Link from './link.view';

export default Link;
